var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiopolymer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 33",
    preserveAspectRatio: "xMidYMid meet",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.818,
    strokeLinecap: "round",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M15.954 8.507v20.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.959 21.543l-4.552-4.552m4.568 4.552l4.553-4.552m-4.685-1.642l-3.356-3.356m3.611 3.356l3.355-3.356"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.841 3.517C9.947 7.357 7 11.697 7 16.537c0 4.842 2.947 7.828 8.841 8.961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.767 3.517c5.894 3.84 8.84 8.18 8.84 13.02 0 4.842-2.946 7.828-8.84 8.961"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiopolymer);
export default __webpack_public_path__ + "static/media/Biopolymer.53725071a107e56aa628cfa23513af66.svg";
export { ForwardRef as ReactComponent };